import { createContext } from "react";

export const StorageContext = createContext()